import { call, cancel, delay, FixedTask, put, spawn } from 'typed-redux-saga';

import { DTMF_COMMANDS, dtmfChangeGridPageSaga, dtmfToggleMuteAudioSecondarySaga } from '../dtmf-commands';
import { setModalType } from '../modal-type/slice';
import { BaseState } from './base-state';
import { StateId } from './types';

const IDLE_STATE_TRANSITIONS: Record<string, StateId> = {
    [DTMF_COMMANDS.commandList.open]: 'command-list',
    [DTMF_COMMANDS.debug.open]: 'debug-menu',
};

const PAGINATION_COMMANDS = [DTMF_COMMANDS.pagination.prevPage, DTMF_COMMANDS.pagination.nextPage];

export class IdleState extends BaseState {
    public id: StateId = 'idle';
    private commandBuffer = '';
    private commandBufferCleanupTask?: FixedTask<void>;

    private *commandBufferCleanup() {
        yield* delay(1500);

        this.commandBuffer = '';
    }

    public *process(command: string) {
        if (this.commandBufferCleanupTask) {
            yield* cancel(this.commandBufferCleanupTask);
        }

        const fullCommand = this.commandBuffer + command;

        if (fullCommand === DTMF_COMMANDS.muteAudio.secondaryToggle) {
            yield* call(dtmfToggleMuteAudioSecondarySaga);
            this.commandBuffer = '';
            return;
        }

        if (PAGINATION_COMMANDS.includes(fullCommand)) {
            yield* call(dtmfChangeGridPageSaga, fullCommand);
            this.commandBuffer = '';
            return;
        }

        if (IDLE_STATE_TRANSITIONS[fullCommand]) {
            yield* put(this.context.requestTransitionChannel, IDLE_STATE_TRANSITIONS[fullCommand]);

            return;
        }

        this.commandBuffer += command;
        this.commandBufferCleanupTask = yield* spawn([this, this.commandBufferCleanup]);
    }

    public *onEnter() {
        yield* put(setModalType(null));
    }

    public *onExit() {
        if (this.commandBufferCleanupTask) {
            yield* cancel(this.commandBufferCleanupTask);
        }
    }
}
